module.exports = __webpack_public_path__ + "static/img/map.3408054.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/displacements/map.png
// module id = +m0V
// module chunks = 1